// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"_destinationSlug__loaderContainer__s7nxc","paginationContainer":"_destinationSlug__paginationContainer__QytHl"};